import { ComponentProps } from "react"

import type { AnyFieldApi } from "@tanstack/react-form"

import { Input } from "@/components/ui/Input"
import { cn } from "@/lib/shadcn-utils"

interface FormInputProps extends ComponentProps<"input"> {
  field: AnyFieldApi
}

export function FormInput({ field, className, ...props }: FormInputProps) {
  const hasError = field.state.meta.errors.length > 0

  return (
    <Input
      id={field.name}
      name={field.name}
      value={field.state.value}
      onBlur={field.handleBlur}
      onChange={(e) => {
        field.handleChange(e.target.value)
      }}
      {...props}
      className={cn(
        "tw-border-2 tw-rounded-md focus:tw-outline-none",
        hasError
          ? "tw-border-red-600 focus:tw-border-red-600"
          : "tw-border-gray-500 focus:tw-border-emerald-600",
        className,
      )}
    />
  )
}
